import snakeCase from 'lodash.snakecase'
import { useMemo } from 'react'
import { FormattedMessage } from 'react-intl'

// ///////////////////////
// MARK: TYPES
export interface IHelpersFormattedClazzProps {
  clazz: string
  description?: string | object | undefined
  ignoreTag?: boolean | undefined
  tagName?: React.ElementType
}

// ///////////////////////
// MARK: EXPORTS
export const FormattedClazz: React.FC<IHelpersFormattedClazzProps> = ({
  clazz,
  description,
  ignoreTag,
  tagName,
}) => {
  const clazzParsed = useMemo(() => snakeCase(clazz), [clazz])

  return (
    <FormattedMessage
      id={`lang.${clazzParsed}`}
      defaultMessage={clazz}
      description={description}
      ignoreTag={ignoreTag}
      tagName={tagName}
    />
  )
}
